// extracted by mini-css-extract-plugin
export default {"searchContainer":"po-flip_searchContainer__1OmHV","poFlipHeading":"po-flip_poFlipHeading__2gsb0"};